export const ImageConfig = Object.freeze({
   
})